import { dayjs } from "@thalamos/common";

import { type IncidentWorkItemWithContext } from "../types/index.js";
import { combinePlacesOfSafetyAndOfficerPresenceForms } from "./combinePlacesOfSafetyAndOfficerPresenceForms.js";

export const INCIDENT_DURATION_THRESHOLD_HOURS = 24;

export const hasPlaceOfSafetyInIncidentOrFormValues = (
  incidentWorkItem: IncidentWorkItemWithContext | undefined,
): boolean => {
  if (!incidentWorkItem) {
    return false;
  }
  const placesOfSafety = combinePlacesOfSafetyAndOfficerPresenceForms(
    incidentWorkItem,
  ).unwrapOr([]);
  return placesOfSafety.length > 0;
};

export const getFirstPlaceOfSafetyArrivalDateTime = (
  incidentWorkItem: IncidentWorkItemWithContext | undefined,
): string | undefined => {
  if (!incidentWorkItem) {
    return undefined;
  }

  const placesOfSafety = combinePlacesOfSafetyAndOfficerPresenceForms(
    incidentWorkItem,
  ).unwrapOr([]);

  if (placesOfSafety.length === 0) {
    return undefined;
  }

  const firstPlaceOfSafety = placesOfSafety.at(-1);

  const arrivalDateTime =
    firstPlaceOfSafety?.placeOfSafety.sections.recordPlaceOfSafetyArrival
      ?.arrivalDateTime;

  return arrivalDateTime?.value;
};

export const isPoliceLeftTimeOutOfExpectedRange = (
  dateTimeLeft: string,
  incidentWorkItem: IncidentWorkItemWithContext | undefined,
  preEndIncidentArrivalDateTime?: string,
): boolean => {
  if (!incidentWorkItem && !preEndIncidentArrivalDateTime) {
    return false;
  }

  const detentionStartDateTime =
    (incidentWorkItem &&
      getFirstPlaceOfSafetyArrivalDateTime(incidentWorkItem)) ??
    preEndIncidentArrivalDateTime;

  if (!detentionStartDateTime) {
    return false;
  }

  const incidentDateTimeLeft = dayjs(dateTimeLeft);
  const incidentDateTimeStart = dayjs(detentionStartDateTime);

  const diffInHours = incidentDateTimeLeft.diff(
    incidentDateTimeStart,
    "hour",
    true,
  );

  if (diffInHours >= INCIDENT_DURATION_THRESHOLD_HOURS || diffInHours < 0) {
    return true;
  }
  return false;
};
